
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/parlor-items/[id]/flower",
      function () {
        return require("private-next-pages/parlor-items/[id]/flower.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/parlor-items/[id]/flower"])
      });
    }
  